<template>
  <div ref="chartRef" style="width: 100%; height: 300px;"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "EtfPriceChart",
  props: {
    etfData: {
      type: Object,
      default: () => ({
        etfType: 0,
        worList: []
      })
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    etfData: {
      deep: true,
      handler() {
        this.renderChart();
      }
    }
  },
  mounted() {
    this.initChart();
    this.renderChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartRef);
      window.addEventListener("resize", this.handleResize);
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    },
    formatDate(dateNum) {
      const dateStr = dateNum.toString();
      if (dateStr.length !== 8) return dateStr;
      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(4, 6);
      const day = dateStr.substring(6, 8);
      return `${year}-${month}-${day}`;
    },
    renderChart() {
      if (!this.chart || !this.etfData.worList || this.etfData.worList.length === 0) {
        return;
      }

      const xAxisData = this.etfData.worList.map(item => this.formatDate(item.infoTime));
      const etfType = this.etfData.etfType;

      let series = [];
      let titleText = "";

      const markPointData = this.etfData.worList
        .map((item, index) => {
          if (item.dividend && item.dividend.trim()) {
            return {
              coord: [index, item.profitPre],
              value: '分红',
              itemStyle: {
                color: '#ff4d4f'
              }
            };
          }
          return null;
        })
        .filter(item => item !== null);

      if (etfType === 0) {
        titleText = "单位净值与累计净值";
        series = [
          {
            name: "单位净值",
            type: "line",
            data: this.etfData.worList.map(item => ({
              value: item.unitVal,
              dividend: item.dividend
            })),
            smooth: true,
            lineStyle: {
              width: 2,
              color: "#108ee9"
            },
            itemStyle: {
              color: "#108ee9"
            }
          },
          {
            name: "累计净值",
            type: "line",
            data: this.etfData.worList.map(item => ({
              value: item.totalVal,
              dividend: item.dividend
            })),
            smooth: true,
            lineStyle: {
              width: 2,
              color: "#52c41a"
            },
            itemStyle: {
              color: "#52c41a"
            }
          }
        ];
      } else {
        titleText = "收益率";
        series = [
          {
            name: "每百份收益",
            type: "line",
            data: this.etfData.worList.map(item => ({
              value: item.profitPre,
              dividend: item.dividend
            })),
            smooth: true,
            lineStyle: {
              width: 2,
              color: "#108ee9"
            },
            itemStyle: {
              color: "#108ee9"
            },
            markPoint: {
              data: markPointData,
              label: {
                formatter: '●',
                fontSize: 12
              },
              symbolSize: 20
            }
          },
          {
            name: "七日年化",
            type: "line",
            data: this.etfData.worList.map(item => ({
              value: item.sevenDayApy,
              dividend: item.dividend
            })),
            smooth: true,
            lineStyle: {
              width: 2,
              color: "#52c41a"
            },
            itemStyle: {
              color: "#52c41a"
            }
          }
        ];
      }

      const option = {
        title: {
          text: titleText,
          left: "center",
          textStyle: {
            fontSize: 14,
            fontWeight: "bold"
          }
        },
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            let result = `<div style="font-weight:bold;margin-bottom:8px;">${params[0].axisValue}</div>`;
            let dividendInfo = "";
            params.forEach(item => {
              let unit = "";
              let displayValue = item.value;
              if (typeof item.value === 'object') {
                displayValue = item.value.value;
                if (item.value.dividend && item.value.dividend.trim()) {
                  dividendInfo = `<div style="margin-top:8px;padding-top:8px;border-top:1px dashed #ccc;color:#ff4d4f;">
                    <span>分红:</span>
                    <span style="font-weight:bold;margin-left:10px;">${item.value.dividend}</span>
                  </div>`;
                }
              }
              if (item.seriesName === "每百份收益") {
                unit = "元";
              } else if (item.seriesName === "七日年化") {
                unit = "%";
              }
              result += `<div style="display:flex;justify-content:space-between;min-width:120px;">
                <span>${item.marker}${item.seriesName}:</span>
                <span style="font-weight:bold;margin-left:10px;">${displayValue}${unit}</span>
              </div>`;
            });
            result += dividendInfo;
            return result;
          }
        },
        legend: {
          data: series.map(item => item.name),
          bottom: 10
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "15%",
          top: "15%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xAxisData,
        },
        yAxis: {
          type: "value",
          axisLabel: {
            fontSize: 12
          }
        },
        series: series
      };

      this.chart.setOption(option);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>